import { differenceInCalendarDays, format } from 'date-fns';
import { it } from 'date-fns/locale';
import type { TFormatChatTimestampLabels } from '../types';

const capitalize = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const formatChatTimestamp = (
    timestamp: number,
    labels: TFormatChatTimestampLabels,
    now: Date = new Date(),
): string => {
    const date = new Date(timestamp);
    const daysAgo = differenceInCalendarDays(now, date);

    if (daysAgo <= 0) return format(date, 'HH:mm');
    if (daysAgo === 1) return labels.yesterday;
    if (daysAgo < 7) return capitalize(format(date, 'EEEE', { locale: it }));
    return format(date, 'dd/MM/yy');
};
